import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { WistiaVideoPlayer } from '../../WistiaVideoPlayer/WistiaVideoPlayer';

const HOW_IT_WORKS_VIDEO_WISTIA_ID = '5ztt8fxlf2';

const WistaWrapper = styled(Box)`
    width: auto;
    @media (min-width: 900px) and (max-width: 1050px) {
        width: 500px;
    }

    @media (min-width: 1050px) and (max-width: 1300px) {
        width: 600px;
    }
`;

export default function HowItWorksVideo() {
    return (
        <WistaWrapper
            marginLeft={['none', 'none', '4bu', '4bu']}
            marginTop={['2bu', '2bu', 'none', 'none']}
        >
            <WistiaVideoPlayer
                id={HOW_IT_WORKS_VIDEO_WISTIA_ID}
                style={{ height: '350px', position: 'relative', width: '710px' }}
            />
        </WistaWrapper>
    );
}
